import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    NODO_TIPO_AYUDA,
    NODO_TIPO_LABEL,
    NODO_TIPO_OPCIONES,
} from 'src/app/models/notificacion/whatsapp_flujo.model';

/**
 * Guía de la respuesta automática, en un `p-dialog` que se abre desde el editor.
 * Solo cómo armar los pasos: las restricciones ya las aplica el formulario.
 * Los patrones van en un acordeón cerrado, para abrir solo el que sirve.
 *
 * Los nombres de los tipos salen de las mismas constantes que usa el editor,
 * así que la ayuda no puede quedar nombrándolos distinto del formulario.
 */
@Component({
    selector: 'app-flujo-ayuda',
    templateUrl: './flujo-ayuda.component.html',
    styleUrls: ['./flujo-ayuda.component.scss'],
})
export class FlujoAyudaComponent {

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    readonly tipos = NODO_TIPO_OPCIONES.map((opcion) => ({
        label: NODO_TIPO_LABEL[opcion.value],
        ayuda: NODO_TIPO_AYUDA[opcion.value],
    }));

    cerrar(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}
